import { z } from 'zod';

const values = z.object({
  value: z.number(),
  estimate: z.number(),
  surprise: z.number(),
  surprise_percentage: z.number(),
});

const movePeriod = z.enum(['d1', 'd2', 'w1', 'w2', 'm1']);

const price = z
  .array(
    z.object({
      period: movePeriod,
      change: z.number(),
    })
  )
  .optional();

export const period = z.object({
  reported: z.boolean(),
  reporting_date: z.string(),
  fiscal_period: z.string(),
  fiscal_year: z.number(),
  currency: z.string(),
  eps: values,
  revenue: values,
  price,
});

const earningsResults = z.object({ earnings: z.array(period) });
const earningsPeriod = z.array(period);

export const earnings = {
  path: (entityTag: string) => `earnings/v1/entity/${entityTag}`,
  schema: earningsResults,
};

export type EarningsResults = z.infer<typeof earningsResults>;
export type EarningsPeriods = z.infer<typeof earningsPeriod>;
export type EarningsPeriod = z.infer<typeof period>;
export type EarningsValue = z.infer<typeof values>;
export type PriceMove = z.infer<typeof price>;
export type MovePeriod = z.infer<typeof movePeriod>;
